module.exports = __webpack_public_path__ + "img/tapengine-logo.png";